(function () {
  var PROP_GIFT = '_q4_bogo_gift';
  var PROP_TIER = '_q4_bogo_tier';
  var PROP_TRIGGER = '_q4_bogo_trigger';
  var PROP_UNIT = '_q4_bogo_unit';
  var PAGE_SIZE = 12;
  var THRESHOLDS = [100, 200];
  var STORE_DEFERRED = 'q4_bogo_deferred_slots';

  function readDeferred() {
    try {
      var raw = sessionStorage.getItem(STORE_DEFERRED);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function writeDeferred(ids) {
    try {
      sessionStorage.setItem(STORE_DEFERRED, JSON.stringify(ids || []));
    } catch (e) {}
  }

  function pushUnique(arr, id) {
    id = String(id || '');
    if (!id) return arr;
    if (arr.indexOf(id) === -1) arr.push(id);
    return arr;
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function usdFromCartItem(item) {
    var cents = Number(item.price || 0);
    var dollars = cents / 100;
    var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
    if (rate && rate !== 1) return dollars / rate;
    return dollars;
  }

  function isGiftLine(item) {
    var props = item.properties || {};
    return props[PROP_GIFT] === '1' || props[PROP_GIFT] === 1 || props[PROP_GIFT] === true;
  }

  function usdFromCents(cents) {
    var dollars = Number(cents || 0) / 100;
    var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
    if (rate && rate !== 1) return dollars / rate;
    return dollars;
  }

  function tierFromUsd(price) {
    if (price >= THRESHOLDS[1]) return 3;
    if (price >= THRESHOLDS[0]) return 2;
    if (price > 0) return 1;
    return 0;
  }

  function imageUrl(value) {
    if (typeof value === 'string') return value;
    if (value && typeof value === 'object') return value.src || value.url || '';
    return '';
  }

  function giftImage(product, variant) {
    return imageUrl(variant && variant.featured_image) || imageUrl(product && product.image);
  }

  function pickPreviewGifts(catalog, tier, universes, excludeHandle) {
    var pool = giftsForTier(catalog, tier).filter(function (g) {
      return !!giftImage(g, (g.variants || []).filter(function (v) { return variantInTier(v, tier); })[0]);
    });
    var same = [];
    var rest = [];
    pool.forEach(function (g) {
      var match = (g.universes || []).some(function (u) {
        return universes.indexOf(u) !== -1;
      });
      if (g.handle === excludeHandle) return;
      if (match) same.push(g);
      else rest.push(g);
    });
    var picked = [];
    var seen = {};
    function add(list) {
      list.forEach(function (g) {
        if (picked.length >= 3) return;
        var img = giftImage(g, (g.variants || []).filter(function (v) { return variantInTier(v, tier); })[0]);
        if (!img || seen[img]) return;
        seen[img] = true;
        picked.push({ title: g.title, image: img, handle: g.handle });
      });
    }
    add(same);
    add(rest);
    if (picked.length < 3) {
      add(pool.filter(function (g) { return g.handle === excludeHandle; }));
    }
    return picked;
  }

  function variantEligible(catalog, variantId) {
    var ids = catalog.eligible_variant_ids || [];
    var n = Number(variantId);
    return ids.indexOf(n) !== -1 || ids.indexOf(String(variantId)) !== -1 || ids.indexOf(String(n)) !== -1;
  }

  function productByVariant(catalog, variantId) {
    var id = Number(variantId);
    var sid = String(variantId);
    var products = catalog.eligible_products || [];
    for (var i = 0; i < products.length; i++) {
      var vids = products[i].variant_ids || [];
      if (vids.indexOf(id) !== -1 || vids.indexOf(sid) !== -1) return products[i];
    }
    return null;
  }

  function usdPriceForItem(catalog, item) {
    var fromCart = usdFromCartItem(item);
    if (fromCart > 0) return fromCart;
    var product = productByVariant(catalog, item.variant_id || item.id);
    if (product && product.min_price != null) return Number(product.min_price);
    return 0;
  }

  function giftProps(item) {
    return (item && item.properties) || {};
  }

  function giftTrigger(item) {
    var v = giftProps(item)[PROP_TRIGGER];
    return v == null ? '' : String(v);
  }

  function giftUnit(item) {
    var v = giftProps(item)[PROP_UNIT];
    var n = Number(v);
    return isFinite(n) && n > 0 ? n : 1;
  }

  function variantAllowedForTier(catalog, variantId, tier) {
    var ids = allowedVariantIds(catalog, tier);
    return ids.indexOf(variantId) !== -1 || ids.indexOf(Number(variantId)) !== -1 || ids.indexOf(String(variantId)) !== -1;
  }

  function matchGiftsToSlots(catalog, slots, gifts) {
    var open = slots.map(function (slot) {
      return {
        slotId: slot.slotId,
        variantId: slot.variantId,
        unit: slot.unit,
        tier: slot.tier,
        taken: false,
      };
    });
    var rows = gifts.map(function (item) {
      return { item: item, qty: Math.max(1, Number(item.quantity || 1)), matched: 0 };
    });

    function take(pred) {
      rows.forEach(function (row) {
        while (row.matched < row.qty) {
          var vid = row.item.variant_id || row.item.id;
          var slot = null;
          for (var i = 0; i < open.length; i++) {
            if (open[i].taken) continue;
            if (!pred(open[i], row, row.matched)) continue;
            if (!variantAllowedForTier(catalog, vid, open[i].tier)) continue;
            slot = open[i];
            break;
          }
          if (!slot) break;
          slot.taken = true;
          row.matched += 1;
        }
      });
    }

    take(function (slot, row, already) {
      return String(slot.variantId) === giftTrigger(row.item) && slot.unit === giftUnit(row.item) + already;
    });
    take(function (slot, row) {
      return String(slot.variantId) === giftTrigger(row.item);
    });
    open.sort(function (a, b) {
      return b.tier - a.tier;
    });
    take(function () {
      return true;
    });

    var filled = {};
    open.forEach(function (slot) {
      if (slot.taken) filled[slot.slotId] = true;
    });
    var invalid = [];
    rows.forEach(function (row) {
      if (row.matched < row.qty) invalid.push({ item: row.item, newQty: row.matched });
    });
    return { filled: filled, invalid: invalid };
  }

  function cartState(catalog, cart) {
    var items = (cart && cart.items) || [];
    var gifts = items.filter(isGiftLine);
    var paid = items.filter(function (item) {
      return !isGiftLine(item) && variantEligible(catalog, item.variant_id || item.id);
    });
    var slots = [];
    var unitByVariant = {};
    paid.forEach(function (item) {
      var price = usdPriceForItem(catalog, item);
      var tier = tierFromUsd(price);
      if (!tier) return;
      var vid = String(item.variant_id || item.id);
      var qty = Math.max(1, Number(item.quantity || 1));
      var start = unitByVariant[vid] || 0;
      for (var i = 1; i <= qty; i++) {
        var unit = start + i;
        slots.push({
          key: item.key,
          variantId: vid,
          title: item.product_title || item.title,
          price: price,
          tier: tier,
          unit: unit,
          slotId: vid + '#' + unit,
        });
      }
      unitByVariant[vid] = start + qty;
    });
    var matched = matchGiftsToSlots(catalog, slots, gifts);
    var unfilled = slots.filter(function (slot) {
      return !matched.filled[slot.slotId];
    });
    var filled = slots.filter(function (slot) {
      return matched.filled[slot.slotId];
    });
    var best = slots.slice().sort(function (a, b) {
      return b.price - a.price;
    })[0] || null;
    return {
      gifts: gifts,
      paid: paid,
      slots: slots,
      unfilled: unfilled,
      filled: filled,
      invalidGifts: matched.invalid,
      best: best,
      tier: best ? best.tier : 0,
    };
  }

  function variantInTier(variant, tier) {
    return (variant.gift_tiers || []).indexOf(tier) !== -1 && variant.available !== false;
  }

  function giftsForTier(catalog, tier) {
    return (catalog.gifts || []).filter(function (g) {
      return (g.variants || []).some(function (v) { return variantInTier(v, tier); });
    });
  }

  function variantsForTier(product, tier) {
    return (product.variants || []).filter(function (v) { return variantInTier(v, tier); });
  }

  function allowedVariantIds(catalog, tier) {
    var ids = [];
    giftsForTier(catalog, tier).forEach(function (g) {
      variantsForTier(g, tier).forEach(function (v) { ids.push(v.id); ids.push(String(v.id)); });
    });
    return ids;
  }

  function variantLabel(product, variant, eligible) {
    var sizeIdx = sizeOptionIndex(product);
    if (sizeIdx >= 0) {
      var val = (variant.options || [])[sizeIdx];
      var unique = eligible.filter(function (v) { return (v.options || [])[sizeIdx] === val; }).length === 1;
      if (val && unique) return val;
    }
    return 'Standard';
  }

  function sizeOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      if (/size/i.test(opts[i].name)) return i;
    }
    return opts.length === 1 ? 0 : -1;
  }

  function isDefaultVariant(variant) {
    return !variant || !variant.title || variant.title === 'Default Title';
  }

  function displayTitle(title, kind) {
    var t = String(title || '').trim();
    t = t.replace(/\s+\d+(?:\.\d+)?\s*cm\s*(?:\([^)]+\))?/gi, '');
    t = t.replace(/\s+\(\s*\d+(?:\.\d+)?\s*(?:"|”|in)?\s*\)/gi, '');
    if (kind === 'Clothing') return t.replace(/\s+/g, ' ').trim() || title;
    t = t.replace(/^(?:Pokemon|Pokémon)\s+Anime\s+Plush(?:ie|\s+Toy)?\s+/i, '');
    t = t.replace(/^.+?\s+Anime\s+Figure\s+/i, '');
    t = t.replace(/^Anime\s+Figure\s+/i, '');
    t = t.replace(/^.+?\s+Plush Toy\s+/i, '');
    t = t.replace(/\s+(?:Collector Statue|PVC Statue|Plushie)\s*$/i, '');
    t = t.replace(/^\d+(?:\.\d+)?(?:"|”|in)?\s+/i, '');
    t = t.replace(/\s+/g, ' ').trim();
    return t || title;
  }

  function gate() {
    if (!window.__q4DrawerGate) window.__q4DrawerGate = { suppress: false, blocked: false };
    return window.__q4DrawerGate;
  }

  function Q4Bogo() {
    this.root = document.getElementById('Q4Bogo');
    this.catalog = window.Q4BogoCatalog;
    this.bestsellerRanks = {};
    try {
      var ranking = this.root && this.root.querySelector('[data-q4-bestsellers]');
      var ranks = this.bestsellerRanks;
      JSON.parse(ranking ? ranking.textContent : '[]').forEach(function (id, index) { ranks[String(id)] = index; });
    } catch (e) {}
    this.page = 0;
    this.category = 'All';
    this.universe = 'All';
    this.selected = null;
    this.selectedVariant = null;
    this.state = null;
    this.currentSlot = null;
    this.skipped = readDeferred();
    this.sessionPicks = [];
    this.view = 'pick';
    this.busy = false;
    this.syncing = false;
    this.pendingCartReason = null;
    this.lastNetKey = '';
    this.lastNetAt = 0;
    this.suppressDrawer = false;
    this.closedByUser = false;
    this.closedCartSig = '';
    this.visibleCount = PAGE_SIZE;
    this.variantChoices = {};
    this.renderedGiftIds = [];
    this.resumeBound = false;
  }

  Q4Bogo.prototype.enabled = function () {
    return this.root && this.root.getAttribute('data-enabled') !== 'false' && this.catalog;
  };

  Q4Bogo.prototype.setDrawerSuppressed = function (on) {
    this.suppressDrawer = !!on;
    var g = gate();
    g.suppress = !!on;
    if (on) {
      g.blocked = true;
      this.forceCloseDrawer();
    }
  };

  Q4Bogo.prototype.forceCloseDrawer = function () {
    if (typeof window.__q4ForceCloseDrawer === 'function') {
      window.__q4ForceCloseDrawer();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') {
      try { drawer.close(); } catch (e) {}
    }
    if (drawer) drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
  };

  Q4Bogo.prototype.allowDrawer = function () {
    this.suppressDrawer = false;
    var g = gate();
    g.suppress = false;
    g.blocked = false;
  };

  Q4Bogo.prototype.currentTier = function () {
    return (this.currentSlot && this.currentSlot.tier) || 0;
  };

  Q4Bogo.prototype.pickerQueue = function () {
    var skipped = this.skipped || [];
    return ((this.state && this.state.unfilled) || []).filter(function (slot) {
      return skipped.indexOf(slot.slotId) === -1;
    });
  };

  Q4Bogo.prototype.setView = function (view) {
    this.view = view;
    var pick = this.root.querySelector('[data-q4-pick-view]');
    var recap = this.root.querySelector('[data-q4-recap]');
    var footerPick = this.root.querySelector('[data-q4-footer-pick]');
    var footerRecap = this.root.querySelector('[data-q4-footer-recap]');
    var filters = this.root.querySelector('[data-q4-filters]');
    if (pick) pick.hidden = view !== 'pick';
    if (recap) recap.hidden = view !== 'recap';
    if (footerPick) footerPick.hidden = view !== 'pick';
    if (footerRecap) footerRecap.hidden = view !== 'recap';
    if (filters) filters.hidden = view !== 'pick';
  };

  Q4Bogo.prototype.trace = function (kind, extra) {
    try {
      window.__q4BogoTrace = window.__q4BogoTrace || [];
      window.__q4BogoTrace.push({ kind: kind, extra: extra || null, at: Date.now() });
    } catch (e) {}
  };

  Q4Bogo.prototype.persistDeferred = function () {
    writeDeferred(this.skipped || []);
  };

  Q4Bogo.prototype.pruneDeferred = function () {
    var live = {};
    ((this.state && this.state.unfilled) || []).forEach(function (slot) {
      live[slot.slotId] = true;
    });
    this.skipped = (this.skipped || []).filter(function (id) {
      return live[id];
    });
    this.persistDeferred();
  };

  Q4Bogo.prototype.deferSlots = function (slots) {
    var self = this;
    (slots || []).forEach(function (slot) {
      pushUnique(self.skipped, slot.slotId || slot);
    });
    this.persistDeferred();
  };

  Q4Bogo.prototype.open = function (opts) {
    opts = opts || {};
    if (!this.enabled() || !this.state) return;
    if (opts.resume) {
      this.skipped = [];
      this.persistDeferred();
    }
    this.sessionPicks = [];
    var queue = this.pickerQueue();
    if (!queue.length) return;
    this.trace('open', { resume: !!opts.resume, queue: queue.map(function (s) { return s.slotId; }) });
    this.currentSlot = queue[0];
    this.setDrawerSuppressed(true);
    this.forceCloseDrawer();
    this.closedByUser = false;
    this.closedCartSig = '';
    this.root.removeAttribute('hidden');
    this.root.hidden = false;
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('q4-bogo-lock');
    this.visibleCount = PAGE_SIZE;
    this.renderedGiftIds = [];
    this.variantChoices = {};
    this.category = 'All';
    this.universe = 'All';
    this.selected = null;
    this.selectedVariant = null;
    this.clearError();
    this.setView('pick');
    this.bindGiftScroll();
    this.renderChrome();
    this.renderFilters();
    this.renderGrid({ reset: true });
    this.syncResumeButtons();
  };

  Q4Bogo.prototype.cartSignature = function (state) {
    state = state || this.state || {};
    var slots = (state.slots || [])
      .map(function (s) {
        return s.slotId;
      })
      .sort()
      .join(',');
    var gifts = (state.gifts || [])
      .map(function (g) {
        return g.key || String(g.variant_id || g.id);
      })
      .sort()
      .join(',');
    return slots + '|' + gifts;
  };

  Q4Bogo.prototype.close = function (opts) {
    opts = opts || {};
    this.root.classList.remove('is-open');
    this.root.hidden = true;
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('q4-bogo-lock');
    this.busy = false;
    if (!opts.keepSuppressed) this.allowDrawer();
  };

  Q4Bogo.prototype.openCartOnce = function () {
    this.allowDrawer();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof window.__q4InstallDrawerGate === 'function') window.__q4InstallDrawerGate();
    if (typeof drawer.open === 'function') drawer.open();
    else drawer.classList.add('active');
  };

  Q4Bogo.prototype.dismissPicker = function () {
    this.closedByUser = true;
    this.closedCartSig = this.cartSignature(this.state);
    this.deferSlots(this.pickerQueue());
    this.setDrawerSuppressed(true);
    this.close({ keepSuppressed: true });
    this.forceCloseDrawer();
    this.syncResumeButtons();
  };

  Q4Bogo.prototype.completePicker = function () {
    var self = this;
    this.close({ keepSuppressed: true });
    this.loadCartSections()
      .then(function (sections) {
        return nativeFetchCart().then(function (cart) {
          self.refreshCartUI(cart, sections);
        });
      })
      .catch(function () {})
      .then(function () {
        self.syncResumeButtons();
        self.openCartOnce();
      });
  };

  Q4Bogo.prototype.clearError = function () {
    var el = this.root.querySelector('[data-q4-error]');
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  };

  Q4Bogo.prototype.showError = function (message) {
    var el = this.root.querySelector('[data-q4-error]');
    if (!el) return;
    el.hidden = false;
    el.textContent = message;
    try { el.scrollIntoView({ block: 'nearest' }); } catch (e) {}
  };

  Q4Bogo.prototype.renderChrome = function () {
    var total = ((this.state && this.state.slots) || []).length;
    var filled = ((this.state && this.state.filled) || []).length;
    var queue = this.pickerQueue();
    var current = this.currentSlot || queue[0];
    var position = filled + (this.skipped || []).length + 1;
    var title = this.root.querySelector('#Q4BogoTitle');
    var note = this.root.querySelector('[data-q4-slot-note]');
    var skipRest = this.root.querySelector('[data-q4-skip-rest]');
    if (this.view === 'recap') {
      if (title) title.textContent = 'Your free gifts';
      if (note) note.hidden = true;
      this.syncUpgradeVisibility();
      return;
    }
    if (title) {
      title.textContent = 'Pick your free gift';
    }
    if (note) {
      if (current && current.title) {
        note.hidden = false;
        note.textContent = 'For ' + current.title.replace(/\s+/g, ' ').trim();
      } else {
        note.hidden = true;
      }
    }
    if (skipRest) skipRest.hidden = queue.length <= 1;
    var upgrade = this.root.querySelector('[data-q4-upgrade]');
    var upgradeCopy = this.root.querySelector('[data-q4-upgrade-copy]');
    var upgradeLink = this.root.querySelector('[data-q4-upgrade-link]');
    var price = current ? current.price : 0;
    this.upgradeEligible = price > 0 && price < 200;
    if (upgradeCopy && upgradeLink) {
      if (price < 100) {
        upgradeCopy.textContent = 'This item unlocks the starter gift pool. A $100+ item unlocks more choices.';
        upgradeLink.textContent = 'Explore $100+ items';
        upgradeLink.href = this.catalog.explore_100 || '/collections/all?view=q4-100-plus';
      } else {
        upgradeCopy.textContent = 'This item unlocks more gift choices. A $200+ item unlocks the widest selection.';
        upgradeLink.textContent = 'Explore $200+ items';
        upgradeLink.href = this.catalog.explore_200 || '/collections/all?view=q4-200-plus';
      }
    }
    this.syncUpgradeVisibility();
  };

  Q4Bogo.prototype.filteredGifts = function () {
    var list = giftsForTier(this.catalog, this.currentTier());
    var category = this.category;
    var universe = this.universe;
    if (category !== 'All') {
      list = list.filter(function (g) { return g.kind === category; });
    }
    if (universe !== 'All') {
      list = list.filter(function (g) { return (g.universes || []).indexOf(universe) !== -1; });
    }
    var ranks = this.bestsellerRanks;
    return list.sort(function (a, b) {
      function categoryRank(gift) {
        if (gift.kind === 'Figures') return 0;
        if (gift.kind === 'Clothing') return 2;
        return 1;
      }
      var categoryDifference = categoryRank(a) - categoryRank(b);
      if (categoryDifference) return categoryDifference;
      var ar = Object.prototype.hasOwnProperty.call(ranks, String(a.id)) ? ranks[String(a.id)] : Number.MAX_SAFE_INTEGER;
      var br = Object.prototype.hasOwnProperty.call(ranks, String(b.id)) ? ranks[String(b.id)] : Number.MAX_SAFE_INTEGER;
      return ar - br;
    });
  };

  Q4Bogo.prototype.renderFilters = function () {
    var wrap = this.root.querySelector('[data-q4-filters]');
    var list = giftsForTier(this.catalog, this.currentTier());
    var categories = ['All'];
    var universes = ['All'];
    list.forEach(function (g) {
      if (g.kind && categories.indexOf(g.kind) === -1) categories.push(g.kind);
      (g.universes || []).forEach(function (u) {
        if (universes.indexOf(u) === -1) universes.push(u);
      });
    });
    function options(values, active) {
      return values
        .map(function (v) {
          return '<option value="' + esc(v) + '"' + (v === active ? ' selected' : '') + '>' + esc(v) + '</option>';
        })
        .join('');
    }
    wrap.innerHTML =
      '<label class="q4-bogo__filter-label">Category<select data-q4-category>' +
      options(categories, this.category) +
      '</select></label><label class="q4-bogo__filter-label">Universe<select data-q4-universe>' +
      options(universes, this.universe) +
      '</select></label><span class="q4-bogo__count" data-q4-count></span>';
  };

  function giftSizeInches(product, variant) {
    if (!product || product.kind === 'Clothing') return '';
    function size(text) {
      text = String(text || '');
      var inches = text.match(/(\d+(?:[.,]\d+)?)\s*(?:["”″]|\binches?\b|\bin\b)/i);
      if (inches) return inches[1].replace(',', '.') + '"';
      var cm = text.match(/(\d+(?:[.,]\d+)?)\s*cm\b/i);
      if (cm) return String(Math.round(Number(cm[1].replace(',', '.')) / 2.54 * 10) / 10) + '"';
      return '';
    }
    return size(variant && variant.title) || size(product.title);
  }

  Q4Bogo.prototype.cardHtml = function (g) {
    var self = this;
    var eligible = variantsForTier(g, this.currentTier());
    var chosenId = this.variantChoices[g.id];
    var selected = eligible[0];
    if (chosenId) {
      eligible.forEach(function (v) {
        if (String(v.id) === String(chosenId)) selected = v;
      });
    }
    var img = giftImage(g, selected);
    var sizeLabel = giftSizeInches(g, selected);
    var variantHtml = '';
    if (eligible.length > 1) {
      variantHtml =
        '<div class="q4-bogo__variant"><span>Size</span><select data-q4-variant-select>' +
        eligible
          .map(function (v) {
            return (
              '<option value="' +
              v.id +
              '"' +
              (selected && String(v.id) === String(selected.id) ? ' selected' : '') +
              '>' +
              esc(variantLabel(g, v, eligible)) +
              '</option>'
            );
          })
          .join('') +
        '</select></div>';
    } else if (eligible.length === 1 && !isDefaultVariant(eligible[0])) {
      variantHtml =
        '<div class="q4-bogo__variant"><span>Size</span><span class="q4-bogo__variant-static">' +
        esc(variantLabel(g, eligible[0], eligible)) +
        '</span></div>';
    }
    return (
      '<article class="q4-bogo__card" data-q4-card="' +
      g.id +
      '"><div class="q4-bogo__art"><img src="' +
      esc(img) +
      '" alt="' +
      esc(displayTitle(g.title, g.kind) || 'Free gift') +
      '" width="400" height="500" loading="lazy"><span class="q4-bogo__free" data-q4-gift-size' + (sizeLabel ? '' : ' hidden') + ' aria-label="Size in inches">' + esc(sizeLabel) + '</span></div><div class="q4-bogo__card-body"><h3>' +
      esc(displayTitle(g.title, g.kind)) +
      '</h3>' +
      '<div class="q4-bogo__gift-price" data-q4-gift-price hidden></div>' +
      variantHtml +
      '<button type="button" class="q4-bogo__choose" data-q4-choose>Choose gift</button></div></article>'
    );
  };

  Q4Bogo.prototype.syncUpgradeVisibility = function () {
    var upgrade = this.root.querySelector('[data-q4-upgrade]');
    if (!upgrade) return;
    var list = this.filteredGifts();
    var allShown = this.view === 'pick' && this.renderedGiftIds.length >= list.length && list.length > 0;
    upgrade.hidden = !(allShown && this.upgradeEligible);
  };

  Q4Bogo.prototype.resetGiftList = function () {
    this.visibleCount = PAGE_SIZE;
    this.renderedGiftIds = [];
    var body = this.root.querySelector('.q4-bogo__body');
    if (body) body.scrollTop = 0;
    this.renderGrid({ reset: true });
  };

  Q4Bogo.prototype.maybeLoadMore = function () {
    if (this.view !== 'pick' || this.busy) return;
    var list = this.filteredGifts();
    if (this.visibleCount >= list.length) return;
    var body = this.root.querySelector('.q4-bogo__body');
    if (!body) return;
    if (body.scrollHeight <= body.clientHeight + 200) this.loadMoreGifts();
  };

  Q4Bogo.prototype.loadMoreGifts = function () {
    var list = this.filteredGifts();
    if (this.visibleCount >= list.length) {
      this.syncUpgradeVisibility();
      return;
    }
    this.visibleCount = Math.min(list.length, this.visibleCount + PAGE_SIZE);
    this.renderGrid();
  };

  Q4Bogo.prototype.bindGiftScroll = function () {
    var self = this;
    var body = this.root.querySelector('.q4-bogo__body');
    if (body && !body.__q4ScrollBound) {
      body.__q4ScrollBound = true;
      body.addEventListener('scroll', function () {
        if (self.view !== 'pick' || self.busy) return;
        if (body.scrollTop + body.clientHeight >= body.scrollHeight - 180) self.loadMoreGifts();
      });
    }
    var sentinel = this.root.querySelector('[data-q4-sentinel]');
    if (sentinel && !sentinel.__q4Observed && 'IntersectionObserver' in window) {
      sentinel.__q4Observed = true;
      new IntersectionObserver(
        function (entries) {
          if (self.view !== 'pick' || self.busy) return;
          if (entries.some(function (entry) { return entry.isIntersecting; })) self.loadMoreGifts();
        },
        { root: body, rootMargin: '160px 0px' }
      ).observe(sentinel);
    }
  };

  Q4Bogo.prototype.renderGrid = function (opts) {
    opts = opts || {};
    var grid = this.root.querySelector('[data-q4-grid]');
    var count = this.root.querySelector('[data-q4-count]');
    var list = this.filteredGifts();
    var seen = {};
    var unique = [];
    list.forEach(function (g) {
      if (!g || seen[g.id]) return;
      seen[g.id] = true;
      unique.push(g);
    });
    list = unique;
    if (opts.reset) {
      this.visibleCount = PAGE_SIZE;
      this.renderedGiftIds = [];
    }
    var shown = list.slice(0, this.visibleCount);
    var self = this;
    var optionCount = list.reduce(function (n, g) { return n + variantsForTier(g, self.currentTier()).length; }, 0);
    if (count) count.textContent = list.length + ' gifts · ' + optionCount + ' eligible options';
    if (!grid) return;
    if (opts.reset || !grid.children.length) {
      grid.innerHTML = shown.map(function (g) { return self.cardHtml(g); }).join('');
      this.renderedGiftIds = shown.map(function (g) { return g.id; });
    } else {
      shown.forEach(function (g) {
        if (self.renderedGiftIds.indexOf(g.id) !== -1) return;
        self.renderedGiftIds.push(g.id);
        grid.insertAdjacentHTML('beforeend', self.cardHtml(g));
      });
    }
    grid.querySelectorAll('[data-q4-card]').forEach(function (card) { self.updateGiftPrice(card); });
    this.syncUpgradeVisibility();
    if (this.busy) this.setChoosing(true);
    var selfLoad = this;
    requestAnimationFrame(function () {
      selfLoad.maybeLoadMore();
    });
  };

  // Fetch current storefront prices only for displayed gifts, once per product/currency.
  var giftPriceRequests = {};
  Q4Bogo.prototype.updateGiftPrice = function (card) {
    var self = this;
    var picked = this.variantFromCard(card);
    if (!picked || !picked.variant) return;
    var code = presentmentCode();
    var route = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var key = route + code + ':' + picked.product.handle;
    if (!giftPriceRequests[key]) {
      giftPriceRequests[key] = fetch(route + 'products/' + encodeURIComponent(picked.product.handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error('Gift price unavailable'); return r.json(); })
        .catch(function () { return null; });
    }
    giftPriceRequests[key].then(function (product) {
      if (!product || !card.isConnected) return;
      var current = self.variantFromCard(card);
      if (!current || !current.variant) return;
      var variant = (product.variants || []).find(function (v) {
        return String(v.id) === String(current.variant.id);
      });
      var row = card.querySelector('[data-q4-gift-price]');
      if (!row) return;
      if (!variant || !isFinite(Number(variant.price)) || Number(variant.price) <= 0) {
        row.hidden = true;
        return;
      }
      var amount = Number(variant.price) / 100;
      var price;
      try {
        price = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: code
        }).format(amount);
      } catch (e) { price = code + ' ' + amount.toFixed(2); }
      row.innerHTML = '<s aria-label="Regular price ' + esc(price) + '">' + esc(price) +
        '</s><strong>' + esc(new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: code, maximumFractionDigits: 0}).format(0)) + '</strong>';
      row.hidden = false;
    });
  };

  Q4Bogo.prototype.setChoosing = function (on) {
    this.root.querySelectorAll('[data-q4-choose], [data-q4-variant-select], [data-q4-skip], [data-q4-skip-rest]').forEach(function (el) {
      el.disabled = !!on;
    });
  };

  Q4Bogo.prototype.variantFromCard = function (cardEl) {
    var id = Number(cardEl.getAttribute('data-q4-card'));
    var product = (this.catalog.gifts || []).find(function (g) { return g.id === id; });
    if (!product) return null;
    var eligible = variantsForTier(product, this.currentTier());
    var select = cardEl.querySelector('[data-q4-variant-select]');
    var vid = select ? select.value : eligible[0] && eligible[0].id;
    var variant = eligible.find(function (v) { return String(v.id) === String(vid); }) || eligible[0];
    return { product: product, variant: variant, eligible: eligible };
  };

  Q4Bogo.prototype.updateCardImage = function (cardEl) {
    var picked = this.variantFromCard(cardEl);
    if (!picked) return;
    var img = cardEl.querySelector('.q4-bogo__art img');
    var src = giftImage(picked.product, picked.variant);
    if (img && src) img.src = src;
    var badge = cardEl.querySelector('[data-q4-gift-size]');
    if (badge) {
      var sizeLabel = giftSizeInches(picked.product, picked.variant);
      badge.textContent = sizeLabel;
      badge.hidden = !sizeLabel;
    }
    this.updateGiftPrice(cardEl);
  };

  Q4Bogo.prototype.chooseAndAdd = function (cardEl) {
    var picked = this.variantFromCard(cardEl);
    if (!picked || !picked.variant) return;
    this.root.querySelectorAll('.q4-bogo__card').forEach(function (el) {
      el.classList.toggle('is-selected', el === cardEl);
    });
    this.selected = picked.product;
    this.selectedVariant = picked.variant;
    this.addGift(cardEl);
  };

  Q4Bogo.prototype.sectionIds = function () {
    var ids = ['cart-drawer'];
    ['header', 'header-group'].forEach(function (id) {
      if (document.getElementById('shopify-section-' + id)) ids.push(id);
    });
    return ids;
  };

  Q4Bogo.prototype.refreshCartUI = function (cart, sections) {
    if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    var state = Object.assign({}, cart || {}, sections ? { sections: sections } : {});
    if (drawer && typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents(state, true);
        return;
      } catch (e) {}
    }
    if (window.cart && typeof window.cart.renderContents === 'function') {
      try { window.cart.renderContents(state, true); } catch (e) {}
    }
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var host = document.getElementById('shopify-section-' + id);
      if (!host || !sections[id]) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = sections[id];
      var fresh = tmp.querySelector('#shopify-section-' + id) || tmp.firstElementChild;
      if (fresh) host.innerHTML = fresh.innerHTML;
    });
    if (typeof window.__q4InstallDrawerGate === 'function') window.__q4InstallDrawerGate();
  };

  Q4Bogo.prototype.loadCartSections = function () {
    return fetch('/?sections=' + this.sectionIds().join(',')).then(function (r) { return r.json(); });
  };

  Q4Bogo.prototype.addGift = function (cardEl) {
    var self = this;
    var slot = this.currentSlot;
    if (this.busy || !this.selectedVariant || !slot) return;
    this.busy = true;
    this.clearError();
    this.setDrawerSuppressed(true);
    this.setChoosing(true);
    var btn = cardEl && cardEl.querySelector('[data-q4-choose]');
    if (btn) btn.textContent = 'Adding…';
    if (cardEl) cardEl.classList.add('is-busy');
    var wantedId = String(this.selectedVariant.id);
    var wantedUnit = String(slot.unit);
    var wantedTrigger = String(slot.variantId);
    var payload = {
      items: [
        {
          id: this.selectedVariant.id,
          quantity: 1,
          properties: {
            _q4_bogo_gift: '1',
            _q4_bogo_tier: String(slot.tier),
            _q4_bogo_trigger: wantedTrigger,
            _q4_bogo_unit: wantedUnit,
          },
        },
      ],
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(readJson)
      .then(function (added) {
        return nativeFetchCart().then(function (cart) {
          return { added: added, cart: cart };
        });
      })
      .then(function (result) {
        var cart = result.cart;
        var found = (cart.items || []).some(function (item) {
          return (
            isGiftLine(item) &&
            String(item.variant_id || item.id) === wantedId &&
            giftTrigger(item) === wantedTrigger &&
            String(giftUnit(item)) === wantedUnit
          );
        });
        if (!found) {
          found = (cart.items || []).some(function (item) {
            return isGiftLine(item) && String(item.variant_id || item.id) === wantedId;
          });
        }
        if (!found) throw new Error('The selected gift was not added. Please try again.');
        self.state = cartState(self.catalog, cart);
        self.sessionPicks.push({
          title: displayTitle(self.selected.title, self.selected.kind),
          image: giftImage(self.selected, self.selectedVariant),
          triggerTitle: slot.title,
        });
        var queue = self.pickerQueue();
        self.busy = false;
        self.setChoosing(false);
        if (cardEl) cardEl.classList.remove('is-busy');
        if (btn) btn.textContent = 'Choose gift';
        if (queue.length) {
          self.setDrawerSuppressed(true);
          self.currentSlot = queue[0];
          self.selected = null;
          self.selectedVariant = null;
          self.variantChoices = {};
          self.setView('pick');
          self.renderChrome();
          self.renderFilters();
          self.resetGiftList();
          return;
        }
        self.completePicker();
      })
      .catch(function (err) {
        self.busy = false;
        self.setChoosing(false);
        self.setDrawerSuppressed(true);
        if (cardEl) cardEl.classList.remove('is-busy');
        if (btn) btn.textContent = 'Choose gift';
        var msg = (err && err.message) || '';
        if (!msg || /<!DOCTYPE|Unexpected token|JSON/i.test(msg)) {
          msg = 'This gift could not be added. Please try again.';
        }
        self.showError(msg);
      });
  };

  Q4Bogo.prototype.advanceAfterSkip = function () {
    if (this.currentSlot) this.deferSlots([this.currentSlot]);
    var queue = this.pickerQueue();
    if (!queue.length) {
      this.showRecap();
      return;
    }
    this.currentSlot = queue[0];
    this.category = 'All';
    this.universe = 'All';
    this.variantChoices = {};
    this.clearError();
    this.setView('pick');
    this.renderChrome();
    this.renderFilters();
    this.resetGiftList();
  };

  Q4Bogo.prototype.skipRest = function () {
    this.deferSlots(this.pickerQueue());
    this.showRecap();
  };

  Q4Bogo.prototype.showRecap = function () {
    var list = this.root.querySelector('[data-q4-recap-list]');
    var note = this.root.querySelector('[data-q4-recap-note]');
    var picks = this.giftRecapFromCart();
    var total = ((this.state && this.state.slots) || []).length;
    var filled = ((this.state && this.state.filled) || []).length;
    if (!picks.length) {
      this.completePicker();
      return;
    }
    this.setView('recap');
    this.renderChrome();
    if (list) {
      list.innerHTML = picks
        .map(function (pick) {
          return (
            '<li><div class="q4-bogo__recap-art"><img src="' +
            esc(pick.image || '') +
            '" alt="' +
            esc(pick.title || 'Free gift') +
            '" width="80" height="100"></div><p><strong>' +
            esc(pick.title) +
            '</strong><span>Free with ' +
            esc(pick.triggerTitle || 'your item') +
            '</span></p></li>'
          );
        })
        .join('');
    }
    if (note) {
      if (filled < total) {
        note.textContent = 'You chose ' + filled + ' of ' + total + ' gifts. You can pick the rest later by adding or updating eligible items.';
      } else {
        note.textContent = 'One free gift with every eligible item purchased.';
      }
    }
  };

  Q4Bogo.prototype.giftRecapFromCart = function () {
    var catalog = this.catalog;
    var slots = (this.state && this.state.slots) || [];
    return ((this.state && this.state.gifts) || []).map(function (item) {
      var product = (catalog.gifts || []).find(function (g) {
        return String(g.id) === String(item.product_id) || (g.variants || []).some(function (v) {
          return String(v.id) === String(item.variant_id || item.id);
        });
      });
      var slot = slots.find(function (s) {
        return String(s.variantId) === giftTrigger(item) && s.unit === giftUnit(item);
      }) || slots.find(function (s) {
        return String(s.variantId) === giftTrigger(item);
      });
      return {
        title: displayTitle((product && product.title) || item.product_title || item.title, product && product.kind),
        image: (product && product.image) || item.image || '',
        triggerTitle: slot ? slot.title : 'your item',
      };
    });
  };

  Q4Bogo.prototype.finishPicker = function () {
    this.completePicker();
  };

  Q4Bogo.prototype.continueWithoutGift = function () {
    this.advanceAfterSkip();
  };

  Q4Bogo.prototype.syncFromCart = function (cart, reason) {
    if (!this.enabled()) return Promise.resolve();
    if (this.syncing) {
      if (reason === 'add' || !this.pendingCartReason) this.pendingCartReason = reason;
      return Promise.resolve();
    }
    var self = this;
    this.syncing = true;
    this.state = cartState(this.catalog, cart);
    var chain = Promise.resolve();
    (this.state.invalidGifts || []).forEach(function (row) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: row.item.key, quantity: row.newQty }),
        });
      });
    });
    var hadInvalid = (this.state.invalidGifts || []).length;
    return chain
      .then(function () {
        if (!hadInvalid) return cart;
        return nativeFetchCart().then(function (fresh) {
          return self.loadCartSections().then(function (sections) {
            self.refreshCartUI(fresh, sections);
            return fresh;
          });
        });
      })
      .then(function (fresh) {
        self.state = cartState(self.catalog, fresh);
        self.pruneDeferred();
        var queue = self.pickerQueue();
        var pickerOpen = self.root.classList.contains('is-open');
        self.trace('sync', { reason: reason, queue: queue.map(function (s) { return s.slotId; }), pickerOpen: pickerOpen });

        if (pickerOpen && self.view === 'pick') {
          if (queue.length) {
            self.setDrawerSuppressed(true);
            var stillCurrent =
              self.currentSlot &&
              queue.some(function (slot) {
                return slot.slotId === self.currentSlot.slotId;
              });
            if (!stillCurrent) {
              self.currentSlot = queue[0];
              self.renderChrome();
              self.renderFilters();
              self.resetGiftList();
            } else {
              self.renderChrome();
            }
          }
          self.syncResumeButtons();
          return;
        }

        if (reason === 'init' || reason === 'gift' || reason === 'change') {
          if (!pickerOpen) {
            if (reason === 'init') self.deferSlots(self.state.unfilled || []);
            self.allowDrawer();
          }
          self.syncResumeButtons();
          return;
        }

        if (reason === 'add' && queue.length) {
          self.open();
          return;
        }

        if (reason === 'add' && !queue.length && !self.closedByUser) {
          self.openCartOnce();
        } else if (!pickerOpen) {
          self.allowDrawer();
        }
        self.syncResumeButtons();
      })
      .catch(function () {})
      .then(function () {
        self.syncing = false;
        var pending = self.pendingCartReason;
        self.pendingCartReason = null;
        if (pending) {
          return nativeFetchCart().then(function (cart2) {
            return self.syncFromCart(cart2, pending);
          });
        }
      });
  };

  Q4Bogo.prototype.ensureResumeButton = function (parent, placement) {
    if (!parent) return null;
    var btn = parent.querySelector(':scope > [data-q4-resume], [data-q4-resume]');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-q4-resume', 'true');
      btn.className = 'q4-bogo-resume';
      btn.textContent = 'Choose your free gifts';
      if (placement === 'after') parent.insertAdjacentElement('afterend', btn);
      else parent.insertAdjacentElement('afterbegin', btn);
    }
    return btn;
  };

  Q4Bogo.prototype.syncResumeButtons = function () {
    var unfilled = ((this.state && this.state.unfilled) || []).length;
    var pickerOpen = !!(this.root && this.root.classList.contains('is-open'));
    var show = unfilled > 0 && !pickerOpen;
    var buttons = [];
    var header = document.querySelector('cart-drawer .drawer__header');
    if (header && header.parentNode) {
      var existing = header.parentNode.querySelector(':scope > [data-q4-resume]');
      var btn = existing || this.ensureResumeButton(header, 'after');
      if (btn) buttons.push(btn);
    }
    var cartPage = document.querySelector('#main-cart-items .js-contents, #main-cart-items, form#cart');
    if (cartPage) {
      var pageBtn = cartPage.querySelector('[data-q4-resume]') || this.ensureResumeButton(cartPage, 'start');
      if (pageBtn) buttons.push(pageBtn);
    }
    document.querySelectorAll('[data-q4-resume]').forEach(function (el) {
      el.hidden = !show;
    });
  };

  Q4Bogo.prototype.bindResume = function () {
    if (this.resumeBound) return;
    this.resumeBound = true;
    var self = this;
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-q4-resume]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        self.open({ resume: true });
      },
      true
    );
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver && !drawer.__q4ResumeObs) {
      drawer.__q4ResumeObs = new MutationObserver(function () {
        self.syncResumeButtons();
      });
      drawer.__q4ResumeObs.observe(drawer, { childList: true, subtree: false });
    }
  };

  Q4Bogo.prototype.bind = function () {
    var self = this;
    this.bindResume();
    this.root.addEventListener('click', function (e) {
      if (e.target.closest('[data-q4-skip-rest]')) {
        if (self.busy) return;
        self.skipRest();
        return;
      }
      if (e.target.closest('[data-q4-skip]')) {
        if (self.busy) return;
        self.continueWithoutGift();
        return;
      }
      if (e.target.closest('[data-q4-recap-done]')) {
        self.completePicker();
        return;
      }
      if (e.target.closest('[data-q4-close]')) {
        self.dismissPicker();
        return;
      }
      var choose = e.target.closest('[data-q4-choose]');
      if (choose) {
        if (self.busy) return;
        self.chooseAndAdd(choose.closest('[data-q4-card]'));
      }
    });
    this.root.addEventListener('change', function (e) {
      if (e.target.matches('[data-q4-category]')) {
        self.category = e.target.value;
        self.resetGiftList();
        return;
      }
      if (e.target.matches('[data-q4-universe]')) {
        self.universe = e.target.value;
        self.resetGiftList();
        return;
      }
      if (e.target.matches('[data-q4-variant-select]')) {
        var card = e.target.closest('[data-q4-card]');
        if (card) self.variantChoices[card.getAttribute('data-q4-card')] = e.target.value;
        self.updateCardImage(card);
      }
    });
    document.addEventListener('q4-bogo:cart-network', function (e) {
      if (self.busy) return;
      var d = e.detail || {};
      var url = d.url || '';
      var method = String(d.method || 'GET').toUpperCase();
      if (!/\/cart\/(add|change|update|clear)/.test(url) || method === 'GET') return;
      var reason = classifyCartReason(url, d.body, self.catalog);
      var key = method + '|' + String(url).split('?')[0] + '|' + bodyKey(d.body);
      var now = Date.now();
      if (key === self.lastNetKey && now - self.lastNetAt < 80) {
        if (reason === 'add') self.pendingCartReason = 'add';
        return;
      }
      self.lastNetKey = key;
      self.lastNetAt = now;
      if (self.syncing) {
        if (reason === 'add' || !self.pendingCartReason) self.pendingCartReason = reason;
        return;
      }
      nativeFetchCart()
        .then(function (cart) {
          return self.syncFromCart(cart, reason);
        })
        .catch(function () {
          if (!self.root.classList.contains('is-open')) self.allowDrawer();
        });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.root.classList.contains('is-open')) self.dismissPicker();
    });
    this.mountPdpOffer();
  };

  Q4Bogo.prototype.mountPdpOffer = function () {
    var els = document.querySelectorAll('[data-q4-pdp-offer]');
    if (!els.length) return;
    var self = this;
    function currentVariantId(root) {
      var form = document.querySelector('product-form form[data-type="add-to-cart-form"], product-form form');
      var input = (form && form.querySelector('[name="id"]')) || document.querySelector('product-form .product-variant-id');
      return (input && input.value) || (root && root.getAttribute('data-variant-id'));
    }
    function pricesFor(el) {
      var node = el.querySelector('[data-q4-pdp-prices]');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent || '[]');
      } catch (e) {
        return [];
      }
    }
    function renderGifts(el, gifts) {
      var host = el.querySelector('[data-q4-pdp-gifts]');
      var options = el.querySelector('[data-q4-pdp-options]');
      if (!host) return;
      if (!gifts.length) {
        host.innerHTML = '';
        if (options) options.hidden = true;
        return;
      }
      if (options) options.hidden = false;
      host.innerHTML = gifts
        .map(function (g) {
          return (
            '<span class="q4-bogo-pdp__gift"><img src="' +
            esc(g.image) +
            '" alt="' +
            esc(g.title || '') +
            '" loading="lazy" width="160" height="200"><span class="q4-bogo-pdp__gift-free">Free</span></span>'
          );
        })
        .join('');
    }
    function sync() {
      els.forEach(function (el) {
        var vid = currentVariantId(el);
        var ok = variantEligible(self.catalog, vid);
        el.hidden = !ok;
        if (!ok) {
          renderGifts(el, []);
          return;
        }
        var prices = pricesFor(el);
        var row = null;
        for (var i = 0; i < prices.length; i++) {
          if (String(prices[i].id) === String(vid)) {
            row = prices[i];
            break;
          }
        }
        var usd = row ? usdFromCents(row.price) : 0;
        if (!usd) {
          var product = productByVariant(self.catalog, vid);
          if (product && product.min_price != null) usd = Number(product.min_price);
        }
        var tier = tierFromUsd(usd);
        if (!tier) {
          el.hidden = true;
          renderGifts(el, []);
          return;
        }
        var product = productByVariant(self.catalog, vid);
        var universes = (product && product.universes) || [];
        var handle = el.getAttribute('data-handle') || (product && product.handle) || '';
        renderGifts(el, pickPreviewGifts(self.catalog, tier, universes, handle));
      });
    }
    sync();
    document.addEventListener(
      'change',
      function (e) {
        if (!e.target) return;
        if (e.target.name === 'id' || e.target.closest('variant-radios, variant-selects, fieldset, .product-form__input')) {
          sync();
        }
      },
      true
    );
    var input = document.querySelector('product-form .product-variant-id, product-form [name="id"]');
    if (input && window.MutationObserver) {
      new MutationObserver(sync).observe(input, { attributes: true, attributeFilter: ['value'] });
    }
    document.addEventListener('variant:change', sync);
    document.addEventListener('variant:changed', sync);
  };

  function bodyHasGift(body) {
    try {
      if (typeof body === 'string' && body.indexOf(PROP_GIFT) !== -1) return true;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return !!(body.get('properties[_q4_bogo_gift]') || body.get('_q4_bogo_gift'));
      }
      if (body && typeof body === 'object' && typeof body.has === 'function' && body.has('properties[_q4_bogo_gift]')) return true;
    } catch (e) {}
    return false;
  }

  function variantIdsFromBody(body) {
          var ids = [];
          function add(value) { if (value != null && /^\d+$/.test(String(value))) ids.push(String(value)); }
          try {
            if (!body) return ids;
            if (typeof body === 'string') {
              try { body = JSON.parse(body); }
              catch (e) { body = new URLSearchParams(body); }
            }
            if (body && typeof body.forEach === 'function') {
              body.forEach(function (value, key) {
                if (key === 'id' || /^items\[\d+\]\[?id\]?$/.test(key)) add(value);
              });
            } else if (body && typeof body === 'object') {
              add(body.id);
              (body.items || []).forEach(function (item) { add(item.id); });
            }
          } catch (e) {}
          return ids;
        }

        function variantIdFromBody(body) {
    try {
      if (!body) return null;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return body.get('id') || body.get('items[0][id]') || body.get('items[0]id');
      }
      if (typeof body === 'string') {
        try {
          var parsed = JSON.parse(body);
          if (parsed && parsed.id) return parsed.id;
          if (parsed && parsed.items && parsed.items[0]) return parsed.items[0].id;
        } catch (e) {
          var match = body.match(/(?:^|&)(?:items%5B0%5D%5Bid%5D|items\[0\]\[id\]|id)=(\d+)/);
          if (match) return match[1];
        }
      }
      if (body && typeof body === 'object') {
        if (body.id) return body.id;
        if (body.items && body.items[0]) return body.items[0].id;
      }
    } catch (e) {}
    return null;
  }

  function bodyKey(body) {
    try {
      if (!body) return '';
      if (typeof body === 'string') return body.slice(0, 180);
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var vid = body.get('id') || body.get('items[0][id]') || '';
        return 'fd:' + vid + ':' + (bodyHasGift(body) ? 'gift' : 'paid');
      }
      return String(body).slice(0, 80);
    } catch (e) {
      return '';
    }
  }

  function classifyCartReason(url, body, catalog) {
    if (bodyHasGift(body)) return 'gift';
    if (!/\/cart\/add/.test(String(url || ''))) return 'change';
    var ids = variantIdsFromBody(body);
    if (ids.some(function (id) { return variantEligible(catalog, id); })) return 'add';
    return 'change';
  }

  function readJson(res) {
    return res.text().then(function (text) {
      var data = null;
      try {
        data = JSON.parse(text);
      } catch (e) {
        data = null;
      }
      if (!res.ok || !data) {
        throw new Error('This gift could not be added. Please try again.');
      }
      return data;
    });
  }

  function nativeFetchCart() {
    return window.fetch('/cart.js').then(readJson);
  }

  function presentmentRate() {
    var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
    return rate || 1;
  }

  function presentmentCode() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
  }

  function formatThreshold(usd, opts) {
    opts = opts || {};
    var code = presentmentCode();
    var amount = Number(usd) * presentmentRate();
    var digits;
    if (opts.cents) {
      digits = 2;
    } else if (code === 'CAD') {
      digits = Math.abs(Number(usd) % 1) < 0.001 ? 0 : 2;
      amount = Number(usd);
    } else {
      digits = 0;
      amount = Math.round(amount);
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      }).format(amount);
    } catch (e) {
      return (code === 'CAD' ? '$' : code + ' ') + amount.toFixed(digits);
    }
  }

  function parseBound(value) {
    if (value == null || value === '' || value === 'none') return null;
    var n = Number(value);
    return isFinite(n) ? n : null;
  }

  function inUsdBand(price, min, max) {
    if (price < min) return false;
    if (max != null && price >= max) return false;
    return true;
  }

  function bindHowItWorksLinks() {
    if (document.getElementById('q4-bogo-how')) return;
    document.querySelectorAll('a[href="#q4-bogo-how"], a[href="/#q4-bogo-how"]').forEach(function (a) {
      a.setAttribute('href', '/' + (window.location.search || '') + '#q4-bogo-how');
    });
  }

  function mountHomeOffer(catalog) {
    var root = document.getElementById('q4-bogo-how');
    if (!root || !catalog) return;
    var note = root.querySelector('[data-q4-home-currency-note]');
    if (note) note.hidden = presentmentCode() === 'CAD';
    var stepTiers = root.querySelector('[data-q4-home-step-tiers]');
    if (stepTiers) {
      stepTiers.textContent =
        'Under ' +
        formatThreshold(100) +
        ', ' +
        formatThreshold(100) +
        '–' +
        formatThreshold(199.99) +
        ', or ' +
        formatThreshold(200) +
        '+';
    }
    root.querySelectorAll('[data-q4-tier-card]').forEach(function (card) {
      var max = parseBound(card.getAttribute('data-max'));
      var range = card.querySelector('[data-q4-tier-range]');
      if (!range) return;
      if (max === 100) range.textContent = 'Under ' + formatThreshold(100);
      else if (max === 200) range.textContent = formatThreshold(100) + '–' + formatThreshold(199.99);
      else range.textContent = formatThreshold(200) + '+';
    });
  }

  function mountExplorePage(catalog) {
    var root = document.querySelector('[data-q4-explore]');
    if (!root || !catalog) return;
    var min = parseBound(root.getAttribute('data-min-price')) || 0;
    var max = parseBound(root.getAttribute('data-max-price'));
    var title = root.querySelector('[data-q4-explore-title]');
    if (title) {
      if (max === 100) title.textContent = 'Under ' + formatThreshold(100) + ' items';
      else if (max === 200) title.textContent = formatThreshold(100) + '–' + formatThreshold(199.99) + ' items';
      else if (min >= 200) title.textContent = formatThreshold(200) + '+ items';
      else if (min >= 100) title.textContent = formatThreshold(100) + '+ items';
    }
    var currencyNote = root.querySelector('[data-q4-explore-currency-note]');
    if (currencyNote) currencyNote.hidden = presentmentCode() === 'CAD';
    var items = (catalog.eligible_products || []).filter(function (p) {
      return inUsdBand(Number(p.min_price), min, max);
    });
    var grid = root.querySelector('[data-q4-explore-grid]');
    var filters = root.querySelector('[data-q4-explore-filters]');
    if (!grid) return;
    var universes = ['All'];
    items.forEach(function (p) {
      (p.universes || []).forEach(function (u) {
        if (universes.indexOf(u) === -1) universes.push(u);
      });
    });
    var active = 'All';
    function paint() {
      var list = items.filter(function (p) {
        return active === 'All' || (p.universes || []).indexOf(active) !== -1;
      });
      grid.innerHTML = list
        .map(function (p) {
          return (
            '<a class="q4-explore__card" href="' +
            p.url +
            '"><div class="q4-explore__media"><img src="' +
            (p.image || '') +
            '" alt="' +
            esc(p.title || '') +
            '" width="400" height="500" loading="lazy"></div><p class="q4-explore__kind">Item to buy</p><h3>' +
            esc(p.title) +
            '</h3><p class="q4-explore__price">' +
            formatThreshold(p.min_price, { cents: true }) +
            '</p></a>'
          );
        })
        .join('');
    }
    if (filters) {
      filters.innerHTML = universes
        .map(function (u) {
          return '<button type="button" class="q4-bogo__chip' + (u === 'All' ? ' is-active' : '') + '" data-u="' + u + '">' + u + '</button>';
        })
        .join('');
      filters.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-u]');
        if (!btn) return;
        active = btn.getAttribute('data-u');
        filters.querySelectorAll('.q4-bogo__chip').forEach(function (el) {
          el.classList.toggle('is-active', el === btn);
        });
        paint();
      });
    }
    paint();
  }

  ready(function bootSurfaces() {
    if (!window.Q4BogoCatalog) {
      setTimeout(bootSurfaces, 50);
      return;
    }
    bindHowItWorksLinks();
    mountHomeOffer(window.Q4BogoCatalog);
    mountExplorePage(window.Q4BogoCatalog);
  });

  ready(function boot() {
    var app = new Q4Bogo();
    if (!app.root) return;
    if (app.root.getAttribute('data-enabled') === 'false') return;
    if (!app.catalog) {
      setTimeout(boot, 50);
      return;
    }
    window.Q4BogoApp = app;
    app.bind();
    fetch('/cart.js')
      .then(readJson)
      .then(function (cart) { return app.syncFromCart(cart, 'init'); })
      .catch(function () {});
  });
})();
